<template>
    <Bangle v-if="category === 'bangle'"/>
    <Bracelet v-if="category === 'bracelet'"/>
    <Chain v-if="category === 'chain'"/>
    <Ring v-if="category === 'ring'"/>
    <Earrings v-if="category === 'earring'" />

</template>

<script setup lang="ts">
    import Bangle from "~/components/Product/SingleProduct/Guide/Bangle.vue"
    import Bracelet from "~/components/Product/SingleProduct/Guide/Bracelet.vue"
    import Chain from "~/components/Product/SingleProduct/Guide/Chain.vue"
    import Ring from "~/components/Product/SingleProduct/Guide/Ring.vue"
    import Earrings from "~/components/Product/SingleProduct/Guide/Earrings.vue"

    const props = defineProps(["data", "name"]);
    const category = computed(() => props.data);
    console.log('category', category);
</script>